(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class TabList {
    static queries = {
      container: '.slideshow__tabpanels',
      nextButton: '#slideshow-button-next',
      previousButton: '#slideshow-button-previous',
      tab: '[role=tab]'
    };

    constructor(node) {
      this.container = document.querySelector(TabList.queries.container);
      this.nextButton = document.querySelector(TabList.queries.nextButton);
      this.previousButton = document.querySelector(TabList.queries.previousButton);
      this.tabs = Array.from(node.querySelectorAll(TabList.queries.tab));
      this.tabpanels = [];

      this.focusedTab = null;
      this.selectedTab = null;
      this.isScrolling = false;

      this.container.addEventListener('scrollend', this.onContainerScrollEnd.bind(this));
      this.nextButton.addEventListener('click', this.onNextButtonClick.bind(this));
      this.previousButton.addEventListener('click', this.onPreviousButtonClick.bind(this));

      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => this.onTabPanelIntersection(entry));
        },
        {
          root: this.container,
          rootMargin: '0px',
          scrollMargin: '0px',
          threshold: 0.51
        }
      );

      this.syncTabsAndTabPanels(this.firstTab, { shouldInitialize: true });
    }

    get firstTab() {
      return this.tabs[0];
    }

    get lastTab() {
      return this.tabs[this.tabs.length - 1];
    }

    getNextTab(tab) {
      const index = this.tabs.indexOf(tab);

      if (tab === this.lastTab) {
        return this.firstTab;
      } else {
        return this.tabs[index + 1];
      }
    }

    getPreviousTab(tab) {
      const index = this.tabs.indexOf(tab);

      if (tab === this.firstTab) {
        return this.lastTab;
      } else {
        return this.tabs[index - 1];
      }
    }

    initializeTabPanelFromTab(tab) {
      const id = tab.getAttribute('aria-controls');
      const tabpanel = document.getElementById(id);

      this.tabpanels.push(tabpanel);

      if (tabpanel) {
        this.intersectionObserver.observe(tabpanel);
      }
    }

    scrollToTabPanel(tabpanel) {
      this.isScrolling = true;
      tabpanel.scrollIntoView({
        block: 'nearest',
        container: 'nearest',
        inline: 'nearest'
      });
    }

    setFocusToTab(tab) {
      this.focusedTab = tab;
      tab.focus();
    }

    setTabAttributes(tab, options) {
      if (options.shouldSelect) {
        this.selectedTab = tab;
        tab.removeAttribute('tabindex');
        tab.setAttribute('aria-selected', 'true');
      } else {
        tab.setAttribute('tabindex', '-1');
        tab.setAttribute('aria-selected', 'false');
      }
    }

    syncTabsAndTabPanels(selectedTab, options) {
      for (let i = 0; i < this.tabs.length; i++) {
        const tab = this.tabs[i];
        const shouldSelect = selectedTab === tab;

        this.setTabAttributes(tab, { shouldSelect });

        if (options.shouldInitialize) {
          tab.addEventListener('click', this.onTabClick.bind(this));
          tab.addEventListener('focus', this.onTabFocus.bind(this));
          tab.addEventListener('keydown', this.onTabKeydown.bind(this));
          this.initializeTabPanelFromTab(tab);
        }

        const tabpanel = this.tabpanels[i];
        if (options.shouldScroll && shouldSelect && tabpanel) {
          this.scrollToTabPanel(tabpanel);
        }
      }
    }

    onContainerScrollEnd() {
      this.isScrolling = false;
    }

    onNextButtonClick() {
      const nextTab = this.getNextTab(this.selectedTab);
      this.syncTabsAndTabPanels(nextTab, { shouldScroll: true });
    }

    onPreviousButtonClick() {
      const previousTab = this.getPreviousTab(this.selectedTab);
      this.syncTabsAndTabPanels(previousTab, { shouldScroll: true });
    }

    onTabClick(event) {
      this.syncTabsAndTabPanels(event.currentTarget, { shouldScroll: true });
    }

    onTabFocus(event) {
      this.focusedTab = event.currentTarget;
    }

    onTabKeydown(event) {
      let preventDefault = true;

      switch (event.key) {
        case 'ArrowLeft':
          const previousTab = this.getPreviousTab(this.focusedTab);
          this.setFocusToTab(previousTab);
          break;
        case 'ArrowRight':
          const nextTab = this.getNextTab(this.focusedTab);
          this.setFocusToTab(nextTab);
          break;
        case 'Home':
          this.setFocusToTab(this.firstTab);
          break;
        case 'End':
          this.setFocusToTab(this.lastTab);
          break;
        default:
          preventDefault = false;
          break;
      }

      if (preventDefault) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    onTabPanelIntersection(entry) {
      if (!this.isScrolling) {
        const tabId = entry.target.getAttribute('aria-labelledby');
        const tab = document.getElementById(tabId);

        this.setTabAttributes(tab, { shouldSelect: entry.isIntersecting });
      }
    }
  }

  globalThis.addEventListener('load', () => {
    const tablistQuery = '[role=tablist]';
    const tablists = document.querySelectorAll(tablistQuery);

    for (let i = 0; i < tablists.length; i++) {
      new TabList(tablists[i]);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
